module.exports = __webpack_public_path__ + "img/illustration-stay-productive.99294b1f.png";